// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IuzG","rootNoMargin":"styles_rootNoMargin__2u9NG"};